// extracted by mini-css-extract-plugin
export default {"infoBlock":"InfoBlock_infoBlock__ns6TI","horizontal":"InfoBlock_horizontal__rB5gx"};